"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.number.constructor");

var _vueCountTo = _interopRequireDefault(require("vue-count-to"));

var _BarChart = _interopRequireDefault(require("../components/BarChart"));

var _CardInfoV = _interopRequireDefault(require("@/views/dashboard/components/CardInfo/Agent/CardInfoV2"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "agent-v1",
  props: {
    profile: Object,
    user: Object,
    labels: Array,
    values: Array,
    loadingUser: Boolean,
    loadingProfile: Boolean,
    numberOfDecimal: Number
  },
  components: {
    CountTo: _vueCountTo.default,
    BarChart: _BarChart.default,
    CardInfo: _CardInfoV.default
  },
  computed: {
    cardInfo: function cardInfo() {
      if (Object.keys(this.profile).length === 0) return;
      return [[{
        left: {
          label: this.$t('dashboard.agent.availableQuota'),
          value: parseFloat(this.user.processAvailableAmount)
        },
        center: {
          icon: 'fas fa-file-invoice-dollar',
          style: 'background: Tan'
        },
        right: {
          label: this.$t('dashboard.agent.rechargeTotal'),
          value: parseFloat(this.user.processAmount)
        },
        decimal: true,
        numberOfDecimal: this.numberOfDecimal // unit: this.$store.getters.dollarSign

      }, {
        left: {
          label: this.$t('dashboard.agent.uncreditedAmount'),
          value: parseFloat(this.user.processUncreditedAmount)
        },
        center: {
          icon: 'fas fa-wallet',
          style: 'background: DarkSalmon'
        },
        right: {
          label: this.$t('dashboard.agent.frozenAmount'),
          value: parseFloat(this.user.processFrozenAmount)
        },
        decimal: true,
        numberOfDecimal: this.numberOfDecimal,
        unit: this.$store.getters.dollarSign
      }], [{
        left: {
          label: this.$t('dashboard.agent.queryAPIToday'),
          value: this.profile.organizationQueryApiCountToday
        },
        center: {
          icon: 'fas fa-paper-plane',
          style: 'background: SkyBlue'
        },
        right: {
          label: this.$t('dashboard.agent.paySuccessToday'),
          value: this.profile.organizationRechargeCountToday
        },
        decimal: false,
        numberOfDecimal: this.numberOfDecimal //unit: this.$t('dashboard.agent.smsUnit')

      }, {
        left: {
          label: this.$t('dashboard.agent.profit'),
          value: parseFloat(this.profile.agentProfitToday)
        },
        center: {
          icon: 'fas fa-money-bill-alt',
          style: 'background: MediumAquaMarine'
        },
        right: {
          label: this.$t('dashboard.agent.cost'),
          value: parseFloat(this.profile.organizationRechargeAmountToday)
        },
        decimal: true,
        //  unit: this.$store.getters.dollarSign,
        numberOfDecimal: this.numberOfDecimal
      }]];
    }
  }
};
exports.default = _default;